import { useNavigate } from 'react-router-dom'

export default function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[hsl(220_22%_97%)] px-4">
      <h1 className="text-[80px] font-black text-[#0B111F] leading-none">404</h1>
      <p className="text-[16px] font-semibold text-foreground mt-4">Page not found</p>
      <p className="text-[13px] text-muted-foreground mt-1">
        The page you're looking for doesn't exist or you don't have access.
      </p>
      <button
        onClick={() => navigate('/')}
        className="mt-8 px-6 py-2.5 bg-[#0B111F] text-white rounded-xl text-[13px] font-semibold hover:bg-[#1a2540] transition"
      >
        Go home
      </button>
    </div>
  )
}
